/**
 * @file Agenda Component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { DomainService } from '../../domain.service';
import { GridBaseComponent } from '../grid-base/grid-base.component';
import { AgendaGridBarComponent } from '../agenda-grid-bar/agenda-grid-bar.component';
import { LocalStorageService } from '../../core/local-storage.service';
import { GridService } from '../grid.service';
import { AlertsService } from '../../core/alerts.service';
/**
 * Agenda Component
 */
var AgendaGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaGridComponent, _super);
    /**
     * Constructs an AgendaGridComponent.
     * @param configurationsService Configuration service to get the configuration of this component.
     * @param domainService Domain service to access the backend api.
     */
    function AgendaGridComponent(domainService, localStorageService, gridService, alertsService) {
        var _this = _super.call(this, domainService, localStorageService, gridService, alertsService) || this;
        // Important: visiblity per layer is also per grid type (agenda and planboard)
        _this.visibilityPerLayer = {
            'workpatterns': true,
            'availabilities': true,
            'absences': true,
            'assignments': true,
            'appointments': true,
            'attendants': true,
            'drop-targets': true,
            'violations': false,
            'adhoc': true,
            'template': true,
            'forecast': true,
            'script': true,
            'extra': true,
            'dragsources': (_this.isTouchDevice === true) ? false : true
        };
        return _this;
    }
    Object.defineProperty(AgendaGridComponent.prototype, "selectedResource", {
        /**
         * Gets the Resource of the agenda displayed.
         * @readonly
         * @type {Entity} The Resource entity or null.
         */
        get: function () {
            if (this.gridBar == null || this.gridBar.entitySelector == null) {
                return null;
            }
            return this.gridBar.entitySelector.value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called after the block name is set and the configuration is loaded.
     */
    AgendaGridComponent.prototype.afterInitialize = function () {
        _super.prototype.afterInitialize.call(this);
        var agendaGridBarComponent = this.configuration.components.find(function (item) { return item.component.includes('AgendaGridBarComponent'); });
        if (!agendaGridBarComponent) {
            throw new Error('AgendaGridBarComponent is missing in the configuration');
        }
        this.gridBarSource = agendaGridBarComponent.configuration;
    };
    return AgendaGridComponent;
}(GridBaseComponent));
export { AgendaGridComponent };
